{
  "mar": {
    "title": "Phiếu theo dõi dùng thuốc",
    "loading": "Đang tải phiếu theo dõi...",
    "emptyState": "Người bệnh này không có y lệnh dùng thuốc đang hoạt động",
    "loadError": "Tải thuốc thất bại",
    "retry": "Thử lại",
    "previousDay": "Ngày trước",
    "nextDay": "Ngày sau",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "Ca",
    "dayShiftHeader": "Ca ngày (07:00 - 19:00)",
    "nightShiftHeader": "Ca đêm (19:00 - 07:00)",
    "newOrder": "Y lệnh dùng thuốc mới",
    "printMar": "In phiếu theo dõi",
    "prnSection": "Thuốc khi cần (PRN)",
    "filter": {
      "timeWindow": "Khoảng thời gian",
      "category": "Phân loại",
      "status": "Trạng thái",
      "scheduledOnly": "Chỉ hiển thị theo lịch"
    },
    "adminStatus": {
      "scheduled": "Theo lịch",
      "dueNow": "Đến giờ",
      "overdue": "Quá hạn",
      "administered": "Đã cho",
      "held": "Tạm ngưng",
      "refused": "Từ chối",
      "missed": "Bỏ lỡ"
    },
    "columns": {
      "medication": "Thuốc",
      "drug": "Thuốc",
      "doseRoute": "Liều / Đường dùng",
      "schedule": "Lịch",
      "scheduledTime": "Giờ theo lịch",
      "givenTime": "Giờ dùng",
      "givenBy": "Người cho thuốc",
      "status": "Trạng thái"
    },
    "actions": {
      "administer": "Cho thuốc",
      "hold": "Tạm ngưng",
      "refuse": "Từ chối",
      "skip": "Bỏ qua",
      "missed": "Đánh dấu bỏ lỡ",
      "edit": "Sửa lần dùng thuốc",
      "viewHistory": "Xem lịch sử",
      "givePrn": "Cho PRN"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "NGUY CƠ CAO",
      "indication": "Chỉ định: {{indication}}",
      "lastGiven": "Lần cho cuối: {{time}}",
      "lastGivenBy": "Lần cho cuối: {{time}} bởi {{user}}"
    },
    "orderBadge": {
      "active": "Đang dùng",
      "onHold": "Tạm ngưng",
      "discontinued": "Ngưng dùng"
    },
    "legend": "Chú thích:",
    "summary": {
      "medsGivenToday": "Thuốc đã cho hôm nay: ",
      "ofTotal": "{{given}} trên {{total}}",
      "overdueCount_one": "Quá hạn {{count}}",
      "overdueCount_other": "Quá hạn {{count}}",
      "nextDue": "Lần sau: ",
      "nextDueAt": "{{medName}} lúc {{time}}"
    },
    "tooltip": {
      "given": "(đã cho {{time}})",
      "pending": "Đang ghi nhận… máy chủ chưa xác nhận"
    },
    "doseModal": {
      "title": "Cho thuốc",
      "doseGiven": "Liều đã cho",
      "siteOfAdministration": "Vị trí dùng thuốc",
      "comments": "Ghi chú",
      "vitalsCheck": "Kiểm tra dấu hiệu sinh tồn trước dùng",
      "doubleCheck": "Kiểm tra hai người",
      "verifier": "Người xác nhận",
      "confirm": "Xác nhận cho thuốc"
    },
    "administerDialog": {
      "doseLabel": "Liều dùng",
      "routeLabel": "Đường dùng",
      "siteLabel": "Vị trí dùng (nếu có)",
      "site": {
        "notApplicable": "Không áp dụng",
        "leftArm": "Cánh tay trái",
        "rightArm": "Cánh tay phải",
        "leftDeltoid": "Cơ delta trái",
        "rightDeltoid": "Cơ delta phải",
        "leftGluteal": "Mông trái",
        "rightGluteal": "Mông phải",
        "leftThigh": "Đùi trái",
        "rightThigh": "Đùi phải",
        "abdomen": "Bụng"
      },
      "timeAdministered": "Thời điểm cho thuốc",
      "administeredDateAria": "Ngày cho thuốc",
      "administeredTimeAria": "Giờ cho thuốc",
      "notesLabel": "Ghi chú",
      "notesPlaceholder": "Ghi chú tuỳ chọn..."
    },
    "prnWarning": {
      "title": "Cảnh báo khoảng cách PRN",
      "lastDoseHoursAgo": "Liều trước đã cho cách đây {{hours}} giờ.",
      "minimumInterval": "Khoảng cách tối thiểu là {{hours}} giờ.",
      "lastAdministered": "Lần cho cuối: {{time}}",
      "justificationLabel": "Lý do cho thuốc sớm",
      "justificationRequired": "*",
      "justificationPlaceholder": "Nhập lý do lâm sàng để cho thuốc trước khoảng cách tối thiểu...",
      "cancel": "Huỷ",
      "overrideContinue": "Ghi đè và tiếp tục"
    },
    "toast": {
      "administered": "Đã ghi nhận cho thuốc",
      "administerError": "Ghi nhận cho thuốc thất bại",
      "administerNotImplemented": "Tính năng ghi nhận MAR chưa khả dụng",
      "held": "Đã tạm ngưng dùng thuốc",
      "refused": "Đã ghi nhận người bệnh từ chối",
      "skipped": "Đã bỏ qua lần dùng thuốc này",
      "orderNotActive": "Y lệnh này không còn hiệu lực (đã ngừng, hủy hoặc hoàn tất) nên không thể ghi nhận việc dùng thuốc."
    },
    "holdRefuseDialog": {
      "holdTitle": "Tạm ngưng thuốc",
      "refuseTitle": "Từ chối thuốc",
      "skipTitle": "Bỏ qua thuốc",
      "scheduledLabel": "Theo lịch: {{time}}",
      "holdReasonLabel": "Lý do tạm ngưng",
      "refusalNotesLabel": "Ghi chú từ chối",
      "skipReasonLabel": "Lý do bỏ qua",
      "holdReasonPlaceholder": "Nhập lý do tạm ngưng...",
      "refusalPlaceholder": "Ghi nhận sự từ chối của người bệnh...",
      "skipPlaceholder": "Nhập lý do bỏ qua...",
      "cancel": "Huỷ",
      "confirm": "Xác nhận"
    },
    "contextMenu": {
      "hold": "Tạm ngưng",
      "refuse": "Từ chối",
      "skip": "Bỏ qua"
    },
    "holdReason": {
      "label": "Lý do tạm ngưng",
      "options": {
        "patientNpo": "Người bệnh NPO (nhịn ăn uống)",
        "vitalsOutOfRange": "Dấu hiệu sinh tồn ngoài giới hạn",
        "patientRefused": "Người bệnh từ chối",
        "providerOrder": "Bác sĩ y lệnh ngưng",
        "other": "Khác"
      }
    },
    "give": {
      "title": "Cho thuốc · {{medication}} {{dose}}",
      "scheduledLabel": "Theo lịch {{time}}",
      "patientLabel": "Bệnh nhân",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "Mã bệnh nhân: {{id}}",
      "medicationLabel": "Thuốc",
      "scanPatientPlaceholder": "Quét vòng đeo tay",
      "scanPatientAria": "Quét vòng đeo tay bệnh nhân",
      "scanMedicationPlaceholder": "Quét mã vạch trên bao bì thuốc",
      "scanMedicationAria": "Quét bao bì thuốc",
      "patientMismatch": "Vòng đeo tay này không phải của bệnh nhân này. Không được cho thuốc.",
      "medicationMismatch": "Bao bì này không phải thuốc đã được chỉ định. Không được cho thuốc.",
      "notScannable": "Không thể đối chiếu bằng mã vạch — y lệnh này chưa có mã vạch trong hệ thống",
      "overrideReason": "Lý do cho thuốc mà không quét mã vạch",
      "overrideReasonPlaceholder": "ví dụ: vòng đeo tay bị hỏng; liều pha chế không có mã vạch",
      "pharmacyOverride": "Khoa Dược chưa duyệt thuốc nguy cơ cao này",
      "pharmacyOverridePlaceholder": "Vì sao liều này không thể chờ Khoa Dược duyệt?",
      "timeLabel": "Thời gian",
      "detailsEdit": "Sửa",
      "detailsDone": "Xong",
      "confirmLabel": "Các thông tin này khớp với y lệnh và liều thuốc tôi đang cầm",
      "cancel": "Hủy",
      "submit": "Cho thuốc",
      "witness": {
        "banner": "NGUY CƠ CAO — cần điều dưỡng thứ hai đối chiếu độc lập",
        "usernameLabel": "Tên đăng nhập của điều dưỡng thứ hai",
        "passwordLabel": "Mật khẩu",
        "verify": "Đối chiếu",
        "verifying": "Đang đối chiếu…",
        "verified": "Đã được điều dưỡng thứ hai đối chiếu",
        "rejected": "Không nhận dạng được thông tin đăng nhập.",
        "overrideLabel": "Không có người đối chiếu? Cho thuốc mà không có điều dưỡng thứ hai — lý do",
        "overridePlaceholder": "Vì sao liều này không thể chờ đối chiếu kép độc lập?"
      },
      "refusal": {
        "wrongPatient": "Sai bệnh nhân — vòng đeo tay đã quét không khớp với y lệnh này. Không được cho thuốc.",
        "wrongMedication": "Sai thuốc — bao bì đã quét không khớp với thuốc được chỉ định. Không được cho thuốc.",
        "scanRequired": "Hãy quét vòng đeo tay và thuốc, hoặc nêu lý do không quét.",
        "pharmacyVerificationRequired": "Khoa Dược chưa duyệt y lệnh này. Hãy chờ duyệt, hoặc ghi lý do không thể chờ.",
        "doubleCheckRequired": "Chưa có điều dưỡng thứ hai đối chiếu kép y lệnh này. Hãy nhờ đối chiếu, hoặc ghi lý do không thể chờ.",
        "doubleCheckSelf": "Bạn không thể tự đối chiếu cho lần cho thuốc của chính mình. Phải có điều dưỡng thứ hai đối chiếu."
      },
      "dispense": {
        "handedOver": "{{quantity}} đã bàn giao lúc {{time}}",
        "label": "Cấp phát từ nhà thuốc",
        "none": "Chưa có ghi nhận cấp phát cho y lệnh này",
        "pending": "Đã ghi nhận cấp phát, chưa bàn giao",
        "prepared": "{{quantity}} đã chuẩn bị lúc {{time}}",
        "unavailable": "Không kiểm tra được việc cấp phát — không đọc được bản ghi"
      }
    }
  },
  "status": {
    "active": "Đang dùng",
    "held": "Tạm ngưng",
    "discontinued": "Ngưng dùng",
    "completed": "Hoàn tất",
    "refused": "Từ chối",
    "missed": "Bỏ lỡ",
    "given": "Đã cho"
  },
  "route": {
    "po": "Đường uống",
    "iv": "Tiêm tĩnh mạch",
    "im": "Tiêm bắp",
    "sc": "Tiêm dưới da",
    "in": "Đường mũi",
    "pr": "Đường trực tràng",
    "sl": "Ngậm dưới lưỡi",
    "top": "Bôi ngoài da",
    "neb": "Khí dung",
    "pv": "Đường âm đạo",
    "ng": "Qua ống thông mũi - dạ dày",
    "ophthalmic": "Nhỏ mắt",
    "transdermal": "Qua da"
  },
  "frequency": {
    "bid": "Hai lần mỗi ngày",
    "tid": "Ba lần mỗi ngày",
    "qid": "Bốn lần mỗi ngày",
    "qd": "Một lần mỗi ngày",
    "qhs": "Trước khi đi ngủ",
    "prn": "Khi cần (PRN)",
    "stat": "Tức thì (STAT)",
    "continuous": "Liên tục"
  },
  "formulary": {
    "title": "Danh mục thuốc",
    "searchPlaceholder": "Tìm theo tên thương mại, hoạt chất hoặc mã...",
    "clearSearch": "Xoá tìm kiếm",
    "category": {
      "all": "Tất cả",
      "analgesic": "Giảm đau",
      "antibiotic": "Kháng sinh",
      "antifungal": "Kháng nấm",
      "antiviral": "Kháng vi-rút",
      "cardiac": "Tim mạch",
      "endocrine": "Nội tiết",
      "gi": "Tiêu hoá",
      "neurological": "Thần kinh",
      "psychiatric": "Tâm thần",
      "respiratory": "Hô hấp",
      "other": "Khác"
    },
    "columns": {
      "medication": "Thuốc",
      "genericName": "Hoạt chất",
      "form": "Dạng bào chế",
      "strength": "Hàm lượng",
      "route": "Đường dùng",
      "status": "Trạng thái",
      "schedule": "Phân loại quản lý"
    },
    "highAlertBadge": "Thuốc Cảnh Báo Cao",
    "highAlertTag": "Cảnh Báo Cao",
    "status": {
      "preferred": "Ưu tiên",
      "restricted": "Hạn chế",
      "nonFormulary": "Ngoài danh mục"
    },
    "loading": "Đang tải danh mục thuốc...",
    "loadError": "Không tải được danh mục thuốc",
    "empty": "Không tìm thấy thuốc.",
    "pagination": {
      "showing": "Hiển thị {{from}}-{{to}} trong tổng {{total}}",
      "page": "Trang {{page}} / {{totalPages}}",
      "previous": "Trang trước",
      "next": "Trang sau"
    },
    "details": {
      "close": "Đóng chi tiết",
      "genericName": "Hoạt chất",
      "category": "Nhóm",
      "formStrength": "Dạng bào chế / Hàm lượng",
      "route": "Đường dùng",
      "formularyStatus": "Trạng thái danh mục",
      "deaSchedule": "Phân loại DEA",
      "indications": "Chỉ định",
      "contraindications": "Chống chỉ định",
      "interactions": "Tương tác thuốc",
      "sideEffects": "Tác dụng phụ",
      "dosageGuidelines": "Hướng dẫn liều dùng",
      "specialPopulations": "Đối tượng đặc biệt",
      "storage": "Bảo quản"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "Hàng đợi xác nhận của dược sĩ",
    "subtitle": "Kiểm tra và xác nhận y lệnh thuốc đang chờ",
    "pendingCount": "{{count}} y lệnh chờ",
    "refresh": "Làm mới",
    "searchPlaceholder": "Tìm theo thuốc, tên bệnh nhân hoặc MRN...",
    "priority": {
      "all": "Tất cả mức ưu tiên",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Thường quy",
      "scheduled": "Theo lịch"
    },
    "loadError": "Không tải được hàng đợi y lệnh",
    "retry": "Thử lại",
    "empty": {
      "title": "Đã xử lý hết",
      "description": "Không có y lệnh thuốc nào đang chờ xác nhận."
    },
    "columns": {
      "patient": "Bệnh nhân",
      "medication": "Thuốc",
      "doseRouteFreq": "Liều / Đường / Tần suất",
      "priority": "Ưu tiên",
      "orderingProvider": "Bác sĩ ra y lệnh",
      "ordered": "Thời điểm y lệnh",
      "actions": "Thao tác"
    },
    "row": {
      "unknown": "Không rõ",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "Thuốc kiểm soát {{schedule}}",
      "providerFallback": "Bác sĩ #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "Xác nhận",
      "verifyTooltip": "Xác nhận y lệnh này",
      "reject": "Từ chối",
      "rejectTooltip": "Từ chối và ngừng",
      "confirmReject": "Xác nhận",
      "cancelReject": "Huỷ",
      "rejectReasonPlaceholder": "Lý do từ chối..."
    },
    "toast": {
      "verifySuccess": "Y lệnh #{{id}} đã được xác nhận",
      "verifyError": "Xác nhận y lệnh thất bại",
      "rejectSuccess": "Y lệnh #{{id}} đã từ chối và ngừng",
      "rejectError": "Từ chối y lệnh thất bại",
      "rejectReasonRequired": "Vui lòng nhập lý do từ chối",
      "notIndependent": "Người kê đơn không thể tự duyệt y lệnh của mình.",
      "overrideSuccess": "Y lệnh {{id}} đã hiệu lực mà không có xác minh của dược sĩ",
      "overrideError": "Không thể ghi nhận việc bỏ qua",
      "overrideReasonRequired": "Bỏ qua cần cả mã lý do và giải trình"
    },
    "verifyDialog": {
      "title": "Duyệt y lệnh thuốc",
      "instruction": "Xác nhận từng mục bạn đã kiểm tra. Bắt buộc đủ cả bốn — rà soát một phần không phải là duyệt.",
      "checks": {
        "allergy": "Tôi đã đối chiếu với dị ứng của bệnh nhân",
        "interaction": "Tôi đã rà soát tương tác thuốc",
        "duplicateTherapy": "Tôi đã rà soát trùng lặp điều trị",
        "doseRange": "Tôi đã rà soát liều cho bệnh nhân này"
      },
      "cancel": "Hủy",
      "confirm": "Duyệt y lệnh"
    },
    "override": {
      "action": "Bỏ qua",
      "confirm": "Ghi nhận bỏ qua",
      "cancel": "Huỷ",
      "tooltip": "Tiếp tục mà không có xác minh của dược sĩ. Lý do được ghi lại; không thay thế kiểm tra dược cho thuốc cảnh báo cao.",
      "codeLabel": "Mã lý do bỏ qua",
      "codePlaceholder": "Chọn lý do…",
      "justificationLabel": "Giải trình bỏ qua",
      "justificationPlaceholder": "Vì sao tiếp tục khi chưa có dược duyệt?",
      "code": {
        "pharmacyClosed": "Khoa dược đã đóng",
        "urgentClinicalNeed": "Nhu cầu lâm sàng khẩn cấp",
        "pharmacyUnreachable": "Không liên lạc được khoa dược"
      }
    },
    "clarify": {
      "action": "Làm rõ",
      "tooltip": "Khoa dược mã hoá y lệnh này khác đi. Cần giải quyết trước khi dùng thuốc.",
      "heading": "Khoa dược mã hoá khác với y lệnh",
      "holding": "(giữ y lệnh)",
      "upheld": "Giữ nguyên y lệnh",
      "upheldTooltip": "Y lệnh gốc là đúng; cấp phát như đã ghi.",
      "amended": "Tôi đã sửa",
      "amendedTooltip": "Ghi nhận y lệnh đã được thay đổi.",
      "adopt": "Chấp nhận bản của dược",
      "adoptTooltip": "Chấp nhận bản mã hoá theo thoả thuận thực hành phối hợp hoặc phác đồ P&T.",
      "close": "Đóng",
      "toast": {
        "resolved": "Đã giải quyết; y lệnh trở lại chờ xác minh",
        "error": "Không thể giải quyết việc làm rõ"
      }
    }
  },
  "reconciliation": {
    "title": "Đối chiếu thuốc",
    "subtitle": "{{patient}} | {{mrn}} | Lượt khám #{{encounter}}",
    "complete": "Hoàn tất đối chiếu",
    "loading": "Đang tải thuốc...",
    "column": {
      "home": "Thuốc đang dùng tại nhà",
      "inpatient": "Thuốc nội trú",
      "discharge": "Thuốc xuất viện"
    },
    "emptyHome": "Không tìm thấy thuốc dùng tại nhà.",
    "emptyInpatient": "Không tìm thấy thuốc nội trú.",
    "emptyDischarge": "Chưa có thuốc xuất viện. Hãy chọn tiếp tục hoặc điều chỉnh thuốc ở các cột khác.",
    "changedFromHome": "Đã thay đổi so với thuốc tại nhà",
    "action": {
      "continue": "Tiếp tục",
      "modify": "Điều chỉnh",
      "discontinue": "Ngừng",
      "discontinueShort": "D/C",
      "newOrder": "Mới"
    },
    "addToDischarge": "Thêm vào thuốc xuất viện",
    "remove": "Bỏ",
    "modifyForm": {
      "title": "Điều chỉnh thuốc",
      "dose": "Liều dùng",
      "route": "Đường dùng",
      "frequency": "Tần suất",
      "dosePlaceholder": "Ví dụ: 500mg",
      "routePlaceholder": "Ví dụ: PO",
      "frequencyPlaceholder": "Ví dụ: BID",
      "cancel": "Huỷ",
      "save": "Lưu"
    },
    "back": "Quay lại",
    "toast": {
      "completed": "Đối chiếu thuốc đã hoàn tất",
      "completeError": "Hoàn tất đối chiếu thất bại",
      "atLeastOne": "Vui lòng đối chiếu ít nhất một loại thuốc trước khi hoàn tất"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "Máy tính liều",
      "weightLabel": "Cân nặng bệnh nhân (kg) *",
      "heightLabel": "Chiều cao (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "vd. 70",
      "heightPlaceholder": "vd. 170",
      "gfrPlaceholder": "Tùy chọn",
      "bsaLabel": "BSA đã tính (Mosteller):",
      "calculate": "Tính liều",
      "error": "Không thể tính liều. Backend có thể không có dữ liệu liều cho thuốc này.",
      "renalAdjustment": "Điều chỉnh theo thận:",
      "originalDose": "Liều gốc:",
      "min": "Tối thiểu:",
      "max": "Tối đa:",
      "recommended": "Khuyến nghị: {{dose}} {{unit}}",
      "apply": "Áp dụng liều",
      "method": {
        "weightBased": "Theo cân nặng",
        "bsaBased": "Theo BSA",
        "flat": "Liều cố định",
        "renalAdjusted": "Điều chỉnh theo thận"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "Kê đơn thuốc",
    "submit": "Kê đơn",
    "navButton": "Kê đơn",
    "noActiveEncounter": "Đơn thuốc phải được gắn với một lượt khám đang hoạt động. Hãy mở hoặc tiếp nhận bệnh nhân này vào một lượt khám trước khi kê đơn.",
    "fields": {
      "medication": "Thuốc",
      "dose": "Liều",
      "doseUnit": "Đơn vị",
      "route": "Đường dùng",
      "frequency": "Tần suất",
      "frequencyDescription": "Mô tả tần suất",
      "duration": "Thời gian",
      "durationUnit": "Đơn vị thời gian",
      "totalDoses": "Tổng số liều",
      "isPrn": "Khi cần (PRN)",
      "prnIndication": "Chỉ định khi cần",
      "administrationInstructions": "Hướng dẫn sử dụng",
      "patientInstructions": "Hướng dẫn cho bệnh nhân",
      "quantityDispensed": "Số lượng cấp phát",
      "refillsAuthorized": "Số lần cấp lại được phép",
      "allowSubstitution": "Cho phép thay thế thuốc gốc",
      "pharmacyNotes": "Ghi chú nhà thuốc",
      "indication": "Chỉ định",
      "clinicalIndication": "Chỉ định lâm sàng",
      "priority": "Ưu tiên"
    },
    "sections": {
      "drug": "Thuốc",
      "dosing": "Liều lượng",
      "durationPrn": "Thời gian & khi cần (PRN)",
      "instructions": "Hướng dẫn",
      "dispensing": "Cấp phát",
      "clinical": "Lâm sàng"
    },
    "doseUnitPlaceholder": "vd. mg",
    "drugSearch": {
      "placeholder": "Tìm trong danh mục thuốc…",
      "noResults": "Không có thuốc phù hợp trong danh mục",
      "clear": "Xóa lựa chọn",
      "catalogRequired": "Chọn thuốc từ danh mục để kê đơn",
      "catalogOnly": "Chỉ kê được thuốc trong danh mục, để mọi kiểm tra an toàn đều chạy được.",
      "controlledBadge": "Thuốc kiểm soát — Nhóm {{schedule}}",
      "controlledTag": "Kiểm soát",
      "highAlertBadge": "Thuốc Cảnh Báo Cao",
      "highAlertTag": "Cảnh Báo Cao",
      "contraindications": "Chống chỉ định: {{text}}"
    },
    "route": {
      "oral": "Đường uống (PO)",
      "iv": "Tĩnh mạch (IV)",
      "subcutaneous": "Dưới da (SC)",
      "intramuscular": "Tiêm bắp (IM)",
      "topical": "Bôi ngoài",
      "inhalation": "Hít",
      "rectal": "Đường trực tràng (PR)",
      "ophthalmic": "Nhỏ mắt",
      "transdermal": "Qua da"
    },
    "frequency": {
      "QD": "Một lần/ngày (QD)",
      "BID": "Hai lần/ngày (BID)",
      "TID": "Ba lần/ngày (TID)",
      "QID": "Bốn lần/ngày (QID)",
      "Q4H": "Mỗi 4 giờ (Q4H)",
      "Q6H": "Mỗi 6 giờ (Q6H)",
      "Q8H": "Mỗi 8 giờ (Q8H)",
      "Q12H": "Mỗi 12 giờ (Q12H)",
      "QHS": "Trước khi ngủ (QHS)",
      "PRN": "Khi cần (PRN)",
      "STAT": "Ngay lập tức (STAT)"
    },
    "durationUnit": {
      "days": "Ngày",
      "weeks": "Tuần",
      "months": "Tháng",
      "doses": "Liều"
    },
    "priority": {
      "routine": "Thường quy",
      "asap": "Càng sớm càng tốt",
      "stat": "Khẩn cấp"
    },
    "validation": {
      "prnIndicationRequired": "Chỉ định khi cần là bắt buộc đối với đơn dùng khi cần"
    },
    "contextBar": {
      "ariaLabel": "Bối cảnh kê đơn",
      "allergies": {
        "label": "Dị ứng",
        "none": "Không có dị ứng đã biết",
        "severe": "Nặng"
      },
      "weight": {
        "label": "Cân nặng",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "Chưa ghi nhận"
      },
      "renal": {
        "label": "Chức năng thận",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "Chức năng thận chưa rõ",
        "source": {
          "reported": "báo cáo",
          "computed": "tính toán",
          "unknown": "chưa rõ"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "Đã kê đơn thuốc",
      "error": "Không thể tạo y lệnh. Vui lòng thử lại.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "Đã kê đơn kèm khuyến cáo an toàn",
      "continue": "Tiếp tục"
    },
    "safetyReview": {
      "title": "Cần Xem Xét An Toàn",
      "proceed": "Ghi đè & Kê đơn",
      "cancel": "Hủy",
      "reasonPrompt": "Chọn lý do ghi đè…",
      "freeTextLabel": "Chi tiết bổ sung",
      "freeTextPlaceholder": "Thêm bối cảnh lâm sàng (tùy chọn)",
      "hardBlockNote": "Không thể ghi đè chặn này.",
      "cannotOverride": "Đơn thuốc này không thể tiếp tục — một hoặc nhiều chặn không thể ghi đè.",
      "blockKind": {
        "cds_contraindication": "Chống chỉ định",
        "cds_unavailable": "Không thể sàng lọc an toàn",
        "renal_contraindication": "Chống chỉ định thận",
        "dose_range": "Liều ngoài phạm vi khuyến nghị",
        "pregnancy_contraindication": "Nguy cơ thai kỳ",
        "unknown": "Chặn an toàn bổ sung"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "Đã xem xét tiền sử thủ công",
        "NO_KNOWN_RISK_THIS_PATIENT": "Không có nguy cơ đã biết cho bệnh nhân này",
        "URGENT_CLINICAL_NEED": "Nhu cầu lâm sàng khẩn cấp",
        "OTHER": "Khác (nêu rõ)",
        "BENEFIT_OUTWEIGHS_RISK": "Lợi ích vượt trội rủi ro",
        "DOSE_REDUCED_PER_PROTOCOL": "Giảm liều theo phác đồ",
        "EGFR_NOT_REPRESENTATIVE": "eGFR không đại diện",
        "SPECIALIST_ADVICE": "Tư vấn chuyên khoa",
        "PATIENT_TOLERANT": "Bệnh nhân dung nạp liều này",
        "SPECIALIST_PROTOCOL": "Theo phác đồ chuyên khoa",
        "TITRATING_TO_EFFECT": "Điều chỉnh theo hiệu quả",
        "RANGE_NOT_APPLICABLE": "Phạm vi không áp dụng",
        "STATUS_CONFIRMED_NEGATIVE": "Đã xác nhận không mang thai",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "Lợi ích vượt trội nguy cơ cho thai nhi",
        "CONTRACEPTION_CONFIRMED": "Đã xác nhận biện pháp tránh thai hiệu quả",
        "PREGNANCY_BEING_TERMINATED": "Đang chấm dứt thai kỳ"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
